import { lazy } from "react";

const routes = [
  {
    path: "/orders-reports",
    element: lazy(() => import("../pages/Reports/ordersReport")),
  },
  {
    path: "/sales-reports",
    element: lazy(() => import("../pages/Reports/salesReport")),
  },
  {
    path: "/returns-reports",
    element: lazy(() => import("../pages/Reports/returnsReport")),
  },
  {
    path: "/declinedByShipper-reports",
    element: lazy(() => import("../pages/Reports/declinedByShipper")),
  },
  {
    path: "/commission-reports",
    element: lazy(() => import("../pages/Reports/commissionReport")),
  },
  {
    path: "/remmittance-reports",
    element: lazy(() => import("../pages/Reports/remmittanceReport")),
  },
  {
    path: "/partner-reports",
    element: lazy(() => import("../pages/Reports/partnerReport")),
  },
  {
    path: "/deposite-approval",
    element: lazy(() => import("../pages/Reports/depositeApproval")),
  },
  {
    path: "/collection-ledger",
    element: lazy(() => import("../pages/Reports/collectionLedger")),
  },
  {
    path: "/collection-ledger-view/:affiliateId",
    element: lazy(() => import("../pages/Reports/collectionLedgerView")),
  },
  {
    path: "/commission-ledger",
    element: lazy(() => import("../pages/Reports/commissionLedger")),
  },
  {
    path: "/commission-ledger-view",
    element: lazy(() => import("../pages/Reports/commissionLedgerView")),
  },
  {
    path: "/commission-payout",
    element: lazy(() => import("../pages/Reports/commissionPayout")),
  },
];

export default routes;
